/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */
/*eslint-disable no-undef */
/* global global, Office, self, window */
Office.onReady(() => {
  if (Office.context.requirements.isSetSupported("SharedRuntime", "1.1")) {
    //console.log("ShareRuntimes javaScript Supported")
    // Code that uses API members from the WordApi 1.1 requirement set.
  } else {
    console.log("ShareRuntimes javaScript API Not Supported");
    // Provide diminished experience here. E.g., run alternate code when the user's Word is perpetual Word 2013 (which does not support WordApi 1.1).
  }
});
/**
 * Shows a notification when the add-in command is executed.
 * @param event
 */
async function action(event) {
  // Your code goes here
  if (event.source.id == "Help") {
    const platform = Office?.context?.diagnostics.platform;
    if (platform == Office.PlatformType.OfficeOnline) {
      window.open("https://sfjtechnologies.com/analyze/#/utilities/user-guide");
    } else {
      Office.context.ui.openBrowserWindow("https://sfjtechnologies.com/analyze/#/utilities/user-guide");
    }
  }
  event.completed();
}

function getGlobal() {
  return typeof self !== "undefined"
    ? self
    : typeof window !== "undefined"
    ? window
    : typeof global !== "undefined"
    ? global
    : undefined;
}

const g = getGlobal();

// the add-in command functions need to be available in global scope
g.action = action;